// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.console[data-v-76185c9d] {\n  border: 1px solid #ccc;\n  max-height: 600px;\n  overflow: auto;\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
